var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e71924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6101b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea1824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6101b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecce3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9bc2d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v7.619048h-16z",
    fill: "url(#a)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.85714286 4.57142857h-.76190476v-1.1501116c0-.20984469-.17215613-.37369792-.38452149-.37369792h-.75476655c-.22144718 0-.38452149.16731025-.38452149.37369792v1.7251674.94875373l-.76190476.76190476h8.38095239l-.7619048-.76190476v-.94875373-1.7251674c0-.20984469-.1721561-.37369792-.3845214-.37369792h-.7547666c-.2214472 0-.3845215.16731025-.3845215.37369792v1.1501116h-.76190476v-1.91201636c0-.20984469-.16898529-.37369792-.37743924-.37369792h-1.53083582c-.21305629 0-.37743922.16731025-.37743922.37369792z",
    fill: "url(#d)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.33333333 6.0952381c-.21039418 0-.38095238-.1705582-.38095238-.38095239 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095238.1705582.38095238.38095238 0 .21039419-.17055819.38095239-.38095238.38095239zm0-1.52380953c-.21039418 0-.38095238-.17055819-.38095238-.38095238s.1705582-.38095238.38095238-.38095238c.21039419 0 .38095238.17055819.38095238.38095238s-.17055819.38095238-.38095238.38095238zm2.66666667 1.52380953c-.21039421 0-.38095238-.1705582-.38095238-.38095239 0-.21039418.17055817-.38095238.38095238-.38095238s.38095238.1705582.38095238.38095238c0 .21039419-.17055817.38095239-.38095238.38095239zm0-2.28571429c-.21039421 0-.38095238-.17055819-.38095238-.38095238s.17055817-.38095238.38095238-.38095238.38095238.17055819.38095238.38095238-.17055817.38095238-.38095238.38095238zm2.6666667 2.28571429c-.2103942 0-.3809524-.1705582-.3809524-.38095239 0-.21039418.1705582-.38095238.3809524-.38095238s.3809523.1705582.3809523.38095238c0 .21039419-.1705581.38095239-.3809523.38095239zm0-1.52380953c-.2103942 0-.3809524-.17055819-.3809524-.38095238s.1705582-.38095238.3809524-.38095238.3809523.17055819.3809523.38095238-.1705581.38095238-.3809523.38095238z",
    fill: "url(#e)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.61904762 7.57569379v1.56716335h-.76190476v.76190476h1.52380952v-2.32906811c.44388282-.10459338.76190476-.38681281.76190476-.71855093 0-.42078838-.51167459-.76190476-1.14285714-.76190476-.63118257 0-1.14285714.34111638-1.14285714.76190476 0 .33173812.31802195.61395755.76190476.71855093z",
    fill: "url(#f)",
    mask: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/GI.153f19d62d4d21dc8ec0d737b47ec5f3.svg";
export { ForwardRef as ReactComponent };